import auth from './auth'
import cfg from './config'
import axios from 'axios'

export default {
    decimalToTime: value => {
        let decimalTimeString = value
        let decimalTime = parseFloat(decimalTimeString)
        decimalTime = decimalTime * 60 * 60;
        let hours = Math.floor((decimalTime / (60 * 60)))
        decimalTime = decimalTime - (hours * 60 * 60)
        let minutes = Math.floor((decimalTime / 60))
        decimalTime = decimalTime - (minutes * 60)
        let seconds = Math.round(decimalTime)
        if (hours < 10) {
            hours = "0" + hours
        }
        if (minutes < 10) {
            minutes = "0" + minutes
        }
        if (seconds < 10) {
            seconds = "0" + seconds
        }
        return ("" + hours + ":" + minutes + ":" + seconds)
    },

    getIconList: () => {
        return [
            'bolt',
            'cloud',
            'cloud-rain',
            'cloud-showers-heavy',
            'smog',
            'snowflake',
            'sun',
            'temperature-low',
            'umbrella',
            'water',
            'wind',
            'map-marked',
            'ban',
            'battery-empty',
            'battery-full',
            'battery-half',
            'battery-quarter',
            'battery-three-quarters',
            'bell',
            'bell-slash',
            'door-closed',
            'door-open',
            'exclamation-triangle',
            'eye',
            'eye-slash',
            'lightbulb',
            'lock',
            'lock-open',
            'map-marker',
            'microphone',
            'signal',
            'tint',
            'tint-slash',
            'video',
            'video-slash',
            'volume-up',
            'volume-off',
            'wifi',
            'cog',
            'fan',
            'camera',
            'bug',
            'key',
            'satellite',
            'burn',
            'filter',
            'radiation',
            'broadcast-tower',
            'industry',
            'plug',
            'trash',
            'shower',
            'traffic-light',
            'heartbeat',
            'tv',
            'fish',
            'power-off',
            'oil-can',
            'charging-station',
            'car-battery',
            'gas-pump',
            'tachometer-alt',
            'cloud-sun',
            'beer',
            'flask',
            'glass-whiskey',
            'archway',
            'city',
            'home',
            'house-damage',
            'landmark',
            'school',
            'torii-gate',
            'building',
            'clinic-medical',
            'hospital',
            'igloo',
            'monument',
            'store',
            'university',
            'campground',
            'dungeon',
            'hospital-alt',
            'industry',
            'mosque',
            'store-alt',
            'vihara',
            'church',
            'gopuram',
            'hotel',
            'kaaba',
            'place-of-worship',
            'synagogue',
            'warehouse',
            'chart-pie',
            'chart-area',
            'bullhorn',
            'chart-bar',
            'chart-line',
            'dollar-sign',
            'money-bill',
            'money-bill-alt',
            'money-bill-wave',
            'donate',
            'hand-holding-usd',
            'seedling',
            'chalkboard',
            'satellite-dish',
            'ruler',
            'ruler-combined',
            'ruler-horizontal',
            'ruler-vertical',
            'clock',
            'stopwatch',
            'hourglass',
            'hourglass-end',
            'hourglass-half',
            'hourglass-start',
            'atom',
            'leaf',
            'seeding',
            'solar-panel',
            'plug',
            'coins',
            'cash-register',
            'percentage',
            'hot-tub',
            'shower',
            'swimmer',
            'swimming-pool',
            'sort-amount-down-alt',
            'sort-amount-up',
            'sort-amount-up-alt',
            'sort-amount-down',
            'toggle-off',
            'toggle-on',
            'skull-crossbones',
            'biohazard',
            'prescription-bottle',
            'prescription-bottle-alt',
            'syringe',
            'pills',
            'temperature-low',
            'vial',
            'vials',
            'tablets',
            'signal'
        ]
    },

    randomKey: (length = 8) => {
        let result = ''
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_'
        let counter = 0

        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * characters.length))
            counter += 1
        }

        return result
    },

    formatarDispositivosErros(dispositivosErros) {
        if (!Array.isArray(dispositivosErros) || dispositivosErros.length === 0) {
            return null
        }

        return dispositivosErros.map((item) => {
            const detalhes = item.erros ?? (item.erro ? { erro: item.erro } : {})
            const mensagens = Object.values(detalhes).flat().join(' ')
            return `Dispositivo ${item.dispositivo_id}: ${mensagens}`
        }).join('<br/>')
    },

    dispatchEvent(event, { message, callback = null, callbackClose = null, callbackLabelClose = 'Fechar', callbackLabel = "Continuar" }) {
        try {
            document.dispatchEvent(new CustomEvent(event, {
                detail: {
                    message,
                    callback,
                    callbackClose,
                    callbackLabelClose,
                    callbackLabel
                },
            }))
        } catch (err) {
            console.error(err)
        }
    },

    convertCpfCnpj: (cpf_cnpj) => {
        const numeros = String(cpf_cnpj).replace(/\D/g, '');

        if (numeros.length === 11) {
            return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        } else if (numeros.length === 14) {
            return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        } else {
            return cpf_cnpj;
        }
    },

    convertDate: (date, format = 'date') => {
        switch (format) {
            case 'date':
                return new Date(Date.parse(date)).toLocaleDateString('pt-BR',
                    { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }
                )
            case 'timestamp':
                let ts = Number(date)
                if (isNaN(ts)) return date

                if (ts < 10000000000) {
                    ts = ts * 1000
                }

                return new Date(ts).toLocaleString('pt-BR', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                })
            default:
                return new Date(Date.parse(date)).toLocaleDateString('pt-BR',
                    { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }
                )
        }
    },

    onUserStopsTyping(input, callback, delay = 1000) {
        let timer

        input.addEventListener("input", () => {
            clearTimeout(timer)
            timer = setTimeout(() => {
                callback()
            }, delay)
        })
    },

    formatMoney(value) {
        try {
            if (typeof value == "string") {
                value = value.replace(/\D/g, "")

                if (!value) return "R$ 0,00"

                value = (parseFloat(value) / 100).toFixed(2)
                value = value.replace(".", ",")
                value = "R$ " + value.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            } else {
                value = value.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                })
            }

            return value
        } catch (error) {
            console.log(error)
            return "R$ 0,00"
        }
    },

    justNumbers(value) {
        value = value.replace(/[.,e]/g, "")
        value = value ? parseInt(value) : 0

        return value
    },

    getLocalStorageMeInfos: async () => {
        try {
            const config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
            let endpoint = cfg.base_api_url + cfg.api_v2 + '/me/'
            const changedEmpresa = auth.getChangedEmpresa()
            if (changedEmpresa) {
                endpoint += `?empresa_id=${changedEmpresa}`
            }
            const res = await axios.get(endpoint, config_me)
            return res.data
        } catch (err) {
            console.error('Erro ao buscar informações do usuário:', err)
            return null
        }
    },

    convertLabelStatusLNS: (status) => {
        const statusChanges = {
            "ONLINE": "Ativo",
            "OFFLINE": "Sem comunicação",
            "NUNCA_COMUNICOU": "Nunca comunicou",
            "INATIVO": "Nunca comunicou"
        }

        return statusChanges[status] ?? status
    },

    toSnakeCase(str) {

        return str
            .replace(/[^a-zA-Z0-9_]+/g, ' ')
            .toLowerCase()
            .split(/[\s-]+|_+/)
            .filter(Boolean)
            .join('_')
    },

    toCapitalizeCase(text) {
        if (!text || typeof text !== "string") return "";

        return text.charAt(0).toUpperCase() + text.slice(1);
    },

    generateRandomColor() {
        let r, g, b, brightness;

        do {
            r = Math.floor(Math.random() * 256);
            g = Math.floor(Math.random() * 256);
            b = Math.floor(Math.random() * 256);

            brightness = (r * 299 + g * 587 + b * 114) / 1000;

        } while (brightness > 220);

        return `rgb(${r}, ${g}, ${b})`;
    },

    parseComandoParametros(value) {
        let current = value
        let guard = 0

        while (typeof current === "string" && guard < 5) {
            const trimmed = current.trim()
            if (!trimmed) {
                current = []
                break
            }
            try {
                current = JSON.parse(trimmed)
            } catch (err) {
                current = []
                break
            }
            guard++
        }

        return Array.isArray(current) ? current : []
    },

    stringifyComandoParametros(value) {
        return JSON.stringify(this.parseComandoParametros(value))
    }
}
